import { createSelector } from '@reduxjs/toolkit';
import { ERentTime } from '../../../../packages/JsonQuery';
import { selectRentTime } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: ERentTime.NotDaily },
  { label: 'От года', value: ERentTime.FromYear },
  { label: 'На несколько месяцев', value: ERentTime.FewMonths },
];

export const selectRentalPeriodFilter = createSelector(selectRentTime, value => ({
  label: 'Срок аренды',
  value: [value || ERentTime.NotDaily],
  options: OPTIONS,
}));
